import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Public client: no portal session token is attached
export const publicApi = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const errMsg = (e, fallback = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(', ');
  return fallback;
};

export const QUALIFICATIONS = ['10th / SSLC', '12th / HSC', 'ITI', 'Diploma', 'UG Degree', 'PG Degree', 'Doctorate', 'Others'];
export const LANGUAGES = ['Tamil', 'English', 'Telugu', 'Malayalam', 'Kannada', 'Hindi', 'Japanese', 'Chinese', 'German', 'French', 'Arabic'];
export const CANDIDATE_EXPERIENCE_TYPES = ['Fresher', 'Experienced', 'Return back to work after career break'];
export const EXPERIENCE_YEARS = ['0', '1', '2', '3', '4', '5', 'Others'];
export const EMP_EXPERIENCE = ['Fresher or Current final years', '1–2 Years', '2–5 Years', '5+ Years', 'After Career Break', 'Any'];
export const WORK_MODES = ['Office', 'Hybrid', 'Work From Home / Remote'];
export const SHIFTS = ['Day', 'Night', 'Any'];
export const PARTICIPATION = ['Yes, we will participate', 'Interested – Need further discussion'];
export const INTERVIEW_TYPES = ['Interview Counters', 'Group Discussion', 'Written Test', 'HR Interview', 'Direct Selection', 'Other'];
export const INDUSTRIES = [
  'IT & Software / Information Technology / Analytics / Digital Marketing', 'ITES / BPO / KPO',
  'Banking, Financial Services & Insurance (BFSI)', 'Accounting & Finance', 'Education & EdTech',
  'Healthcare & Pharmaceuticals', 'Manufacturing', 'Automobile & Auto Components', 'Electronics & Electrical',
  'Engineering & Industrial', 'Construction & Real Estate', 'Retail & Consumer', 'E-commerce',
  'FMCG / Consumer Goods', 'Textiles & Garments', 'Food Processing & Food Industry',
  'Hospitality / Hotels / Restaurants', 'Travel & Tourism', 'Logistics / Transportation / Supply Chain',
  'Telecommunications', 'Media / Entertainment / Advertising / Content Creation', 'Sales & Marketing',
  'Customer Service / Customer Support', 'Human Resources / Recruitment', 'Legal & Professional Services',
  'Beauty, Wellness & Personal Care', 'Agriculture & Agribusiness', 'Renewable Energy / Environment',
  'Chemicals & Industrial Products', 'Export / Import / International Trade',
  'Overseas / International Employment', 'Other',
];

export const formatFairDate = (fair) => {
  if (fair?.date_display) return fair.date_display;
  if (!fair?.start_datetime) return '';
  const opts = { day: 'numeric', month: 'long', year: 'numeric' };
  const s = new Date(fair.start_datetime).toLocaleDateString('en-IN', opts);
  const e = fair.end_datetime ? new Date(fair.end_datetime).toLocaleDateString('en-IN', opts) : '';
  return e && e !== s ? `${s} – ${e}` : s;
};

export const venueLine = (fair) => [fair?.venue_name, fair?.city].filter(Boolean).join(', ');

export const isOn = (cfg, key) => cfg?.[key]?.visible !== false;
export const isReq = (cfg, key) => isOn(cfg, key) && !!cfg?.[key]?.required;

export const MOBILE_RE = /^[6-9]\d{9}$/;
export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
